import React, { forwardRef } from 'react'

import './DraggableItem.styles.css';

interface DraggableItemProps {
    isDragging: boolean,
    isOver: boolean,
    isHandle?: boolean,
    className?: string,
    style?: React.CSSProperties,
    children: React.ReactNode
};

const DraggableItem = forwardRef<HTMLDivElement, DraggableItemProps>(({ isDragging, isOver, isHandle, className, style, children }, ref) => {
    return (
        <div className={(className || '') + ' draggable-item' + (isHandle ? ' draggable-item-handle' : '') + (isDragging ? ' is-dragging' : '') + (isOver ? ' is-over' : '')} style={style} ref={ref}>
            { children }
        </div>
    );
});

export default DraggableItem;
